import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["scrollContainer", "fadeOverlay"]

  declare readonly scrollContainerTarget: HTMLElement
  declare readonly fadeOverlayTarget: HTMLElement


  connect() {
    this.scrollContainerTarget.addEventListener("scroll", this.handleScroll)
    this.handleScroll()
  }


  disconnect() {
    this.scrollContainerTarget.removeEventListener("scroll", this.handleScroll)
  }

  private handleScroll = (): void => {
    const container = this.scrollContainerTarget
    const fadeOverlay = this.fadeOverlayTarget

    if (!container || !fadeOverlay) return

    const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 5

    fadeOverlay.classList.toggle('opacity-0', isAtBottom)
    fadeOverlay.classList.toggle('opacity-100', !isAtBottom)
  }
}
